import * as React from 'react';
import { useRef, useState } from 'react';
import type { TextInput } from 'react-native';
import {
    BodyMediumRegular,
    isNonMobileWeb,
    LabelRegular,
    StyledBodyMediumRegularInputNoOutline,
    View,
    XStack,
    YStack,
} from 'smoothie';

import PaycheckRoutingCard from '../../paycheck-routing/common/PaycheckRoutingCard';

interface RuleEditorPercentageProps {
    amount?: number;
    updateAmount: (amount: number) => void;
    percentageRemaining?: number;
}

const RuleEditorPercentage = ({
    amount,
    updateAmount,
    percentageRemaining = 100,
}: RuleEditorPercentageProps) => {
    const [amountWidth, setAmountWidth] = useState(0);

    const inputRef = useRef<TextInput>(null);

    return (
        <YStack gap={8}>
            {/* hidden element to help determine input width so it only stretches as far as its content */}
            <View
                position="absolute"
                opacity={0}
                onLayout={(e) => {
                    setAmountWidth(e.nativeEvent.layout.width);
                }}
            >
                <BodyMediumRegular>{amount}</BodyMediumRegular>
            </View>

            <LabelRegular marginLeft={8} color="$gray1100">
                Percentage
            </LabelRegular>
            <PaycheckRoutingCard
                onPress={() => {
                    inputRef.current?.focus();
                }}
            >
                <XStack alignItems="center">
                    <StyledBodyMediumRegularInputNoOutline
                        ref={inputRef}
                        keyboardType={isNonMobileWeb ? 'default' : 'number-pad'}
                        padding={0}
                        value={(amount ?? '').toString()}
                        onChangeText={(incomingValue) => {
                            if (incomingValue === '') {
                                updateAmount(0);
                                return;
                            }

                            const numberValue = parseInt(incomingValue, 10);

                            if (
                                !Number.isNaN(numberValue) &&
                                numberValue >= 0 &&
                                numberValue <= 100
                            ) {
                                updateAmount(numberValue);
                            }
                        }}
                        returnKeyType="done"
                        height={22}
                        width={amountWidth || 1}
                    />
                    <BodyMediumRegular
                        marginLeft={amountWidth ? undefined : -1}
                    >
                        %
                    </BodyMediumRegular>
                </XStack>
            </PaycheckRoutingCard>
            <LabelRegular color="$gray1100" paddingHorizontal={8}>
                You have {percentageRemaining}% remaining
            </LabelRegular>
        </YStack>
    );
};

export default RuleEditorPercentage;
